export default function PHP_parse_ini_file() {
  return (
    <div>
      <h1>PHP_parse_ini_file</h1>
    </div>
  );
}
